/**
 * Deep-link search for Admin → Events filtered to a scheduled job's event type.
 * Keys match `adminSearchSchema` in `routes/_authenticated/admin.tsx`.
 */
export interface ScheduledJobEventsBridgeSearch {
  tab: "events";
  view: "events";
  eventType: string;
  status?: "FAILED";
}

export function buildScheduledJobEventsBridgeSearch(
  eventType: string,
  options?: { status?: "FAILED" },
): ScheduledJobEventsBridgeSearch {
  return {
    tab: "events",
    view: "events",
    eventType,
    ...(options?.status ? { status: options.status } : {}),
  };
}

export function buildScheduledJobEventsBridgeLocation(
  eventType: string,
  options?: { status?: "FAILED" },
) {
  return {
    pathname: "/admin" as const,
    search: buildScheduledJobEventsBridgeSearch(eventType, options),
  };
}
